export function getDisplayName(WrappedComponent) {
  const displayName =
    WrappedComponent.displayName || WrappedComponent.name || "Component";
  return displayName;
}
